import React from 'react';
import PageContainer from '../../layout/PageContainer';
import CorredorLiquidacionList from '../liquidacion/CorredorLiquidacionList';

const CorredorCreditoLiquidacionListContainer = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'CORREDOR', url: '/corredor/liquidacion-credito' },
      { id: 2, name: 'LIQUIDACIÓN CRÉDITO' },
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'credito',
      showFilter: true,
    }}
  >
    {(corredor) => <CorredorLiquidacionList corredor={corredor} tipo="credito" />}
  </PageContainer>
);

export default CorredorCreditoLiquidacionListContainer;
